import { useState } from "react";

import { avatarThumbnail } from "~/components/MessageBubble";
import { useAuthenticatedMedia } from "~/hooks/useAuthenticatedMedia";
import { getInitials } from "~/lib/initials";
import type { Client } from "~/lib/matrix";

export function PersonAvatar({
  client,
  avatarUrl,
  name,
  size,
  radius = "var(--chat-radius-full)",
}: {
  client: Client | null;
  avatarUrl: string | null | undefined;
  name: string;
  size: number;
  radius?: string;
}) {
  const mxc = avatarUrl?.startsWith("mxc://") ? avatarUrl : null;
  const media = useAuthenticatedMedia(client, mxc, {
    reuseAvatar: true,
    thumbnail: avatarThumbnail(size),
  });
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const src = media.src && media.src !== failedSrc ? media.src : null;
  return (
    <span
      aria-hidden
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: size,
        height: size,
        borderRadius: radius,
        overflow: "hidden",
        background: "var(--chat-surface-raised)",
        color: "var(--chat-fg-secondary)",
        fontFamily: "var(--chat-font-sans)",
        fontSize: Math.max(10, Math.round(size * 0.4)),
        fontWeight: 500,
        flexShrink: 0,
      }}
    >
      {src ? (
        <img
          src={src}
          alt=""
          onError={() => setFailedSrc(src)}
          style={{ width: size, height: size, objectFit: "cover" }}
        />
      ) : (
        getInitials(name) || "–"
      )}
    </span>
  );
}
